import { render, staticRenderFns } from "./complete-request-backfill.vue?vue&type=template&id=2f71508a&scoped=true&"
import script from "./complete-request-backfill.vue?vue&type=script&lang=js&"
export * from "./complete-request-backfill.vue?vue&type=script&lang=js&"
import style0 from "./complete-request-backfill.vue?vue&type=style&index=0&id=2f71508a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f71508a",
  null
  
)

export default component.exports